import {Injectable} from '@angular/core';

type RedirectPayload = { url: string; state?: any } | null;

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  private redirectPayload: RedirectPayload = null;

  set(redirectPayload: RedirectPayload) {
    this.redirectPayload = redirectPayload;
  }

  isAvailable(): boolean {
    return this.redirectPayload !== null;
  }

  consume(): RedirectPayload {
    const redirectPayload = this.redirectPayload;
    this.redirectPayload = null;
    return redirectPayload;
  }
}
